import { isEmpty } from 'lodash';
import React from 'react';

import { OrderReceiptsValidation } from 'components';
import { Order } from 'types';

type Props = {
  order: Order;
};

export const OrderValidationColumn: React.FC<Props> = ({ order }) => (
  <div>
    {!isEmpty(order.receiptsValidation) && (
      <OrderReceiptsValidation order={order} />
    )}
  </div>
);
